import React, { useState, useEffect, useCallback, useRef } from "react";
import { Layout, Button } from "antd";
import { Row, Form, Input, Col, Select, Collapse, Dropdown, Menu, notification } from "antd";

import TopHeader from "../common/TopHeader/TopHeader";
import Sidebar from "../common/Sidebar/Sidebar";
// import FooterDashboard from "../common/FooterDashboard/FooterDashboard";
import { MinusCircleTwoTone, PlusCircleTwoTone, SearchOutlined, MoreOutlined, EditOutlined, ClearOutlined, FireOutlined, FundViewOutlined } from "@ant-design/icons";
import QuestionnairesApi from "../common/Apis/QuestionnairesApi";
import ProductionApi from "../common/Apis/ProductionApi";
import AddTempReheat from "../common/Models/Reheat/AddTemp";
import AddWaste from "../common/Models/Waste/AddWaste";
import ReheatProcessApi from "../common/Apis/ReheatProcessApi";
import StockLevel from "../common/Models/AfterCook/StockLevel";
import HistoryProduct from "../common/Models/Reheat/HistoryProduct";
import StockLevelApi from "../common/Apis/StockLevelApi";
import RecipeApi from "../common/Apis/RecipeApi";
import jsPDF from "jspdf";
import EmptyBox from "../common/CommonUI/EmptyBox";
import Pagination from "../common/Pagination/Pagination"; 
import "../common/Pagination/Pagination.css"; 

const Reheat = () => {
    const { Content } = Layout;
    const { Panel } = Collapse;
    const [formadd2] = Form.useForm();
    const [ReheatProcess, setReheatProcess] = React.useState([]);
    const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));


    const [PaginatePage, setPaginatePage] = useState(0);
    const [PaginatetotalPages, settotalPages] = useState(null);
    const [PaginateLimit, setPaginateLimit] = useState(10);
    const [totalElements, setTotalElements] = useState(0);

    const [FilterEnable, setFilterEnable] = useState(true);
    const [formPaginate] = Form.useForm();
    formPaginate.setFieldsValue({
        paginate: PaginateLimit,
    });
    const handlesetPaginateLimit = (value) => {
        setPaginateLimit(value);
        setCurrentPage(1);
        formPaginate.setFieldsValue({
            paginate: value,
        });


        if (FilterEnable) {
            ReheatProcessApi.ListreheatProcess(0, value)
                .then((response) => {
                    settotalPages(response.totalPages);
                    setReheatProcess(response.payloadDto);
                    setTotalElements(response.totalElements);

                })
                .catch((err) => {
                    console.log(err);
                });
        } else {
            let singleLineString = filterRecipe
                .map((obj) => {
                    if (obj.answerType === "%") {
                        return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
                    } else if (obj.answerType === "=") {
                        return `${obj.title}${obj.answerType}${obj.name}`;
                    } else {
                        return `${obj.title}=BETWEEN${createDateTimestamp(
                            obj.answerType
                        )}AND${createDateTimestamp(obj.name)}`;
                    }
                })
                .join("&");

            let filderData = window.btoa(
                "componentCode=REHEAT_PROCESS&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
            );
            QuestionnairesApi.FilterQuestionsetNext(filderData, 0, value)
                .then((response) => {
                    settotalPages(response.totalPages);
                    setReheatProcess(response.payloadDto);
                    setTotalElements(response.totalElements);

                })
                .catch((err) => { });
        }
    };
    const [currentPage, setCurrentPage] = useState(1);

    const handlePageChange = (page) => {
        setCurrentPage(page);
        let pageNew = page - 1


        if (FilterEnable) {
            ReheatProcessApi.ListreheatProcess(pageNew, PaginateLimit)
                .then((response) => {
                    setPaginatePage(pageNew)
                    settotalPages(response.totalPages);
                    setReheatProcess(response.payloadDto);
                    setTotalElements(response.totalElements);

                })
                .catch((err) => {
                    console.log(err);
                });

        } else {

            let singleLineString = filterRecipe
                .map((obj) => {
                    if (obj.answerType === "%") {
                        return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
                    } else if (obj.answerType === "=") {
                        return `${obj.title}${obj.answerType}${obj.name}`;
                    } else {
                        return `${obj.title}=BETWEEN${createDateTimestamp(
                            obj.answerType
                        )}AND${createDateTimestamp(obj.name)}`;
                    }
                })
                .join("&");

            let filderData = window.btoa(
                "componentCode=REHEAT_PROCESS&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
            );
            QuestionnairesApi.FilterQuestionsetNext(filderData, pageNew, PaginateLimit)
                .then((response) => {
                    setPaginatePage(pageNew)
                    settotalPages(response.totalPages);
                    setReheatProcess(response.payloadDto);
                    setTotalElements(response.totalElements);

                })
                .catch((err) => { });
        }
    };

    const getReheatProcess = useCallback(() => {
        ReheatProcessApi.ListreheatProcess(PaginatePage, PaginateLimit).then((response) => {
            settotalPages(response.totalPages);
            setReheatProcess(response.payloadDto);
            setTotalElements(response.totalElements);

        })
            .catch((err) => {
                console.log(err);
            });
    }, []);
    const [isLoading, setIsLoading] = useState(false);
    const PageLoading = useCallback(() => {
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
        }, 800);
    }, []);

    useEffect(() => {
        getReheatProcess();
        PageLoading();
    }, [getReheatProcess, PageLoading]);


    const handleRemovefilterProduction = (FiltergetProductionIndex) => {
        const newfilterProduction = [...filterRecipe];
        newfilterProduction.splice(FiltergetProductionIndex, 1);
        setFilterRecipe(newfilterProduction);
        if (FiltergetProductionIndex == 0) {
            getReheatProcess();
        }
    };
    const handleClear = () => {
        setFilterEnable(true);
        getReheatProcess();
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
        }, 800);
        setFilterRecipe([
            {
                title: "",
                answerType: "",
                name: "",
            },
        ]);
    };
    const formRef = useRef(null);

    const [filterRecipe, setFilterRecipe] = useState([
        {
            title: "",
            answerType: "",
            name: "",
        },
    ]);

    const handleAddfilterRecipe = () => {
        setFilterRecipe([
            ...filterRecipe,
            {
                title: "",
                answerType: "",
                name: "",
            },
        ]);
    };

    const handleSubmit = (data) => {
        setFilterEnable(false);
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
        }, 800);
        let singleLineString = filterRecipe
            .map((obj) => {
                if (obj.answerType === "%") {
                    return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
                } else if (obj.answerType === "=") {
                    return `${obj.title}${obj.answerType}${obj.name}`;
                } else {
                    return `${obj.title}=BETWEEN${createDateTimestamp(
                        obj.answerType
                    )}AND${createDateTimestamp(obj.name)}`;
                }
            })
            .join("&");

        let filderData = window.btoa(
            "componentCode=REHEAT_PROCESS&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
        );
        QuestionnairesApi.FilterQuestionsetNext(filderData, 0, PaginateLimit)
            .then((response) => {
                setCurrentPage(1);
                settotalPages(response.totalPages);
                setReheatProcess(response.payloadDto);
                setTotalElements(response.totalElements);

            })
            .catch((err) => { });
    };
    const createDateTimestamp = (Cdate) => {
        const date = new Date(Cdate);
        const unixTime = Math.floor(date.getTime());
        return unixTime;
    };
    const handleChangeTitle = (FiltergetproductionIndex, value) => {
        const newfilterProduction = [...filterRecipe];
        newfilterProduction[FiltergetproductionIndex].title = value;
        setFilterRecipe(newfilterProduction);
        const fieldName = 'name' + FiltergetproductionIndex;
        const fieldName2 = 'nameto' + FiltergetproductionIndex;
        formadd2.setFieldsValue({
            [fieldName]: null,
            [fieldName2]: null,
        });

    };
    const handleChangeAnswertype = (FiltergetproductionIndex, value) => {
        const newfilterProduction = [...filterRecipe];
        newfilterProduction[FiltergetproductionIndex].answerType = value;
        setFilterRecipe(newfilterProduction);
    };

    const handleChangename = (FiltergetproductionIndex, value) => {
        const newfilterProduction = [...filterRecipe];
        newfilterProduction[FiltergetproductionIndex].name = value;
        setFilterRecipe(newfilterProduction);
    };

    const paginatedData = ReheatProcess;

    const [modalStockLevelVisible, setModalStockLevelVisible] = useState(false);
    const [modalStockLevelData, setModalStockLevelData] = useState("");
    const [AfterCookId, setAfterCookId] = useState("");
    const [StockLevelProducts, setStockLevelProducts] = React.useState();
    const [StockLevelIncreadiant, setStockLevelIncreadiant] = React.useState([]);

    const handleOpenStockLevelModal = (ProductionID) => {
        ProductionApi.SingleProduction(ProductionID)
            .then((response2) => {
                setAfterCookId(response2.payload);
                RecipeApi.SingleRecipe(response2.payload?.recipeDTO?.id)
                    .then((responseRecipe) => {
                        setStockLevelIncreadiant(responseRecipe?.payload?.ingredientsDTO)
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            })
            .catch((err) => {
                console.log(err);
            });
        StockLevelApi.ListStockProduction(ProductionID)
            .then((response) => {
                setStockLevelProducts(response?.payload[0])

            })
            .catch((err) => {
                console.log(err);
            });

        setModalStockLevelVisible(true);
    };
    const handlEditeCloseModal = () => {
        setModalStockLevelVisible(false);
    };

    const [modalwasteVisible, setModalwasteVisible] = useState(false);
    const [modalwasteData, setModalwasteData] = useState("");

    const handleOpenWasteModal = (ProductionID) => {
        ProductionApi.SingleProduction(ProductionID)
            .then((response2) => {
                setAfterCookId(response2.payload);
                setModalwasteData(response2.payload);
                RecipeApi.SingleRecipe(response2.payload?.recipeDTO?.id)
                    .then((responseRecipe) => {
                        setStockLevelIncreadiant(responseRecipe?.payload?.ingredientsDTO)
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            })
            .catch((err) => {
                console.log(err);
            });
        StockLevelApi.ListStockProduction(ProductionID)
            .then((response) => {
                setStockLevelProducts(response?.payload[0])

            })
            .catch((err) => {
                console.log(err);
            });
        setModalwasteVisible(true);
    };

    const handlwasteCloseModal = () => {
        setModalwasteVisible(false);
    };
    const [modalHistoryVisible, setModalHistoryVisible] = useState(false);
    const [modalHistoryData, setModalHistoryData] = useState("");
    const [modalHistoryData2, setModalHistoryData2] = useState("");

 const handleOpenHistoryModal = (ProductionID) => {
    ProductionApi.SingleProduction(ProductionID)
        .then((response) => {
            // Encode the batch code to handle special characters like #
            const encodedBatchCode = encodeURIComponent(response?.payload?.batchCode);
            
            ProductionApi.SingleProductionHistory(encodedBatchCode)
                .then((response2) => {
                    setModalHistoryData2(response?.payload);
                    setModalHistoryData(response2.payload);
                    setModalHistoryVisible(true);
                })
                .catch((err) => {
                    console.log(err);
                    if (err.apiError?.status) {
                        notification.open({
                            message: <span style={{ fontWeight: "bold" }}>Error</span>,
                            description: err.apiError.message,
                            closeIcon: false,
                            duration: 3,
                            style: {
                                backgroundColor: "#fff2f0",
                                color: "red",
                            },
                        });
                    }
                });
        })
        .catch((err) => {
            console.log(err);
        });
};

    const handlHistoryCloseModal = () => {
        setModalHistoryVisible(false);
    };


    const [modalReheatVisible, setModalReheatVisible] = useState(false);
    const [modalReheatData, setModalReheatData] = useState("");

    const handleOpenReheatModal = (ReheatID) => {
        ReheatProcessApi.SinglereheatProcess(ReheatID)
            .then((response) => {
                ProductionApi.SingleProduction(response?.payload?.productionDTO?.id)
                    .then((response2) => {
                        setModalReheatData(response2?.payload)
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            })
            .catch((err) => {
                console.log(err);
            });
        setModalReheatVisible(true);
    };

    const handlReheatCloseModal = () => {
        setModalReheatVisible(false);
    };

    function convertTo12HourFormat(timeString) {
        const [hours, minutes] = timeString.split(':').map(Number);
        const amOrPm = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = (hours % 12 || 12).toString().padStart(2, '0');
        const formattedMinutes = minutes.toString().padStart(2, '0');
        return `${formattedHours}:${formattedMinutes} ${amOrPm}`;
    }
    function formatTime3(time) {
        const timeNew = parseInt(time, 10);
        const options = { hour: "2-digit", minute: "2-digit" };
        const formattedTime = new Date(timeNew).toLocaleTimeString(
            "en-US",
            options
        );

        return formattedTime;
    }
    const handlePrintButtonClick2 = () => {
        const doc = new jsPDF({
            orientation: 'landscape',
            unit: 'mm',
            format: [297, 210],
        });

        const fontSize = 10;


        let yPos = 35;
        doc.setFontSize(fontSize);

        const currentDate = new Date().toLocaleDateString();
        const currentTime = new Date().toLocaleTimeString();
        const promises = [];


        for (let i = 0; i < parseInt(PaginatetotalPages); i++) {
            if (FilterEnable) {
                promises.push(
                    ReheatProcessApi.ListreheatProcess(i, PaginateLimit).then((response) => {
                        doc.setFont('Poppins', 'bold');
                        doc.text(`Reheat`, 150, 10, { align: 'center' });
                        doc.setFont('Poppins', 'normal');
                        doc.setFontSize(10);
                        doc.text(`Date : ${currentDate}`, 10, 20);
                        doc.text(`Time : ${currentTime}`, 10, 25);
                        doc.setFontSize(fontSize);

                        // Draw table headers and borders
                        doc.setFont('Poppins', 'bold');
                        doc.text('Date', 15, yPos);
                        doc.text('Time', 40, yPos);
                        doc.text('Product Description', 60, yPos);
                        doc.text('Temp', 110, yPos);
                        doc.text('Batch Code', 125, yPos);
                        doc.text('OUBD', 160, yPos);
                        doc.text('Sell by Date	', 180, yPos);
                        doc.text('Quantity', 210, yPos);
                        doc.text('Reheated by', 250, yPos);
                        doc.setFont('Poppins', 'normal');
                        doc.setLineWidth(0.1);
                        doc.rect(12, yPos - 5, 280, 10);
                        yPos += 10;


                        response.payloadDto.forEach(row => {
                            const date = formatDate(row?.createdDate);
                            const cookingTime = (row?.createdDate) ? formatTime3(row?.createdDate) : '';
                            const productionName = (row?.productionDTO?.productionName) ? row?.productionDTO?.productionName : row?.productionName;
                            const temp = (row?.temperatureInCelsius !== "N/A") ? row?.temperatureInCelsius + ' °C' : "N/A";
                            const batchCode = row?.productionDTO?.batchCode;
                            const ubd = formatDate(row?.ubd);
                            const sellByDate = formatDate(row?.productionDTO?.sellByDate);
                            const quantity = row?.productionDTO?.quantity + " " + row?.productionDTO?.unit;
                            const createdBy = row?.tenantDTO?.createdBy;


                            doc.setFontSize(fontSize);

                            doc.text(date, 15, yPos);
                            doc.text(cookingTime, 40, yPos);
                            doc.text(productionName, 60, yPos);
                            doc.text(temp, 110, yPos);
                            doc.text(batchCode, 125, yPos);
                            doc.text(ubd, 160, yPos);
                            doc.text(sellByDate, 180, yPos);
                            doc.text(quantity, 210, yPos);
                            const allergenLines = doc.splitTextToSize(createdBy, 40);
                            doc.text(allergenLines, 250, yPos);

                            const rowHeight = 10 * Math.max(allergenLines.length, 1);

                            if (yPos + rowHeight + 10 > 297) { // Check if remaining space is not enough for next row
                                doc.addPage();
                                yPos = 35; // Reset yPos for the new page
                            } else {
                                doc.setLineWidth(0.1);
                                doc.rect(12, yPos - 5, 280, rowHeight);
                                yPos += rowHeight;
                            }
                        });

                        if (i === parseInt(PaginatetotalPages)) {
                            doc.addPage();
                            yPos = 35;
                        }
                    }).catch((err) => {
                        console.log(err);
                    })
                );
            } else {

                let singleLineString = filterRecipe
                    .map((obj) => {
                        if (obj.answerType === "%") {
                            return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
                        } else if (obj.answerType === "=") {
                            return `${obj.title}${obj.answerType}${obj.name}`;
                        } else {
                            return `${obj.title}=BETWEEN${createDateTimestamp(
                                obj.answerType
                            )}AND${createDateTimestamp(obj.name)}`;
                        }
                    })
                    .join("&");

                let filderData = window.btoa(
                    "componentCode=REHEAT_PROCESS&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
                );

                promises.push(
                    QuestionnairesApi.FilterQuestionsetNext(filderData, i, PaginateLimit).then((response) => {
                        doc.setFont('Poppins', 'bold');
                        doc.text(`Reheat`, 150, 10, { align: 'center' });
                        doc.setFont('Poppins', 'normal');
                        doc.setFontSize(10);
                        doc.text(`Date : ${currentDate}`, 10, 20);
                        doc.text(`Time : ${currentTime}`, 10, 25);
                        doc.setFontSize(fontSize);

                        // Draw table headers and borders
                        doc.setFont('Poppins', 'bold');
                        doc.text('Date', 15, yPos);
                        doc.text('Time', 40, yPos);
                        doc.text('Product Description', 60, yPos);
                        doc.text('Temp', 110, yPos);
                        doc.text('Batch Code', 125, yPos);
                        doc.text('OUBD', 160, yPos);
                        doc.text('Sell by Date	', 180, yPos);
                        doc.text('Quantity', 210, yPos);
                        doc.text('Reheated by', 250, yPos);
                        doc.setFont('Poppins', 'normal');
                        doc.setLineWidth(0.1);
                        doc.rect(12, yPos - 5, 280, 10);
                        yPos += 10;


                        response.payloadDto.forEach(row => {
                            const date = formatDate(row?.createdDate);
                            const cookingTime = (row?.createdDate) ? formatTime3(row?.createdDate) : '';
                            const productionName = (row?.productionDTO?.productionName) ? row?.productionDTO?.productionName : row?.productionName;
                            const temp = (row?.temperatureInCelsius !== "N/A") ? row?.temperatureInCelsius + ' °C' : "N/A";
                            const batchCode = row?.productionDTO?.batchCode;
                            const ubd = formatDate(row?.ubd);
                            const sellByDate = formatDate(row?.productionDTO?.sellByDate);
                            const quantity = row?.productionDTO?.quantity + " " + row?.productionDTO?.unit;
                            const createdBy = row?.tenantDTO?.createdBy;


                            doc.setFontSize(fontSize);

                            doc.text(date, 15, yPos);
                            doc.text(cookingTime, 40, yPos);
                            doc.text(productionName, 60, yPos);
                            doc.text(temp, 110, yPos);
                            doc.text(batchCode, 125, yPos);
                            doc.text(ubd, 160, yPos);
                            doc.text(sellByDate, 180, yPos);
                            doc.text(quantity, 210, yPos);
                            const allergenLines = doc.splitTextToSize(createdBy, 40);
                            doc.text(allergenLines, 250, yPos);

                            const rowHeight = 10 * Math.max(allergenLines.length, 1);

                            if (yPos + rowHeight + 10 > 297) { // Check if remaining space is not enough for next row
                                doc.addPage();
                                yPos = 35; // Reset yPos for the new page
                            } else {
                                doc.setLineWidth(0.1);
                                doc.rect(12, yPos - 5, 280, rowHeight);
                                yPos += rowHeight;
                            }
                        });

                        if (i === parseInt(PaginatetotalPages)) {
                            doc.addPage();
                            yPos = 35;
                        }
                    }).catch((err) => {
                        console.log(err);
                    })
                );
            }


        }

        const reversedPromises = promises.map(promise =>
            promise.then(result =>
                new Promise(resolve =>
                    setTimeout(() => resolve(result), 0)
                )
            )
        );

        Promise.all(reversedPromises)
            .then(() => {
                window.open(doc.output('bloburl'), '_blank');
            })
            .catch((err) => {
                console.log(err);
            });

    };

    const renderTableRows = () => {
        if (paginatedData.length > 0) {
            return paginatedData.map((item) => (
                <tr key={item?.id} className="text-center">

                    <td style={{ width: "4%" }} className="pt-3 ">
                        {formatDate(item?.createdDate)}
                    </td>
                    <td style={{ width: "4%" }} className="pt-3 ">
                        {convertTo12HourFormat(item?.productionDTO?.cookingTime)}
                    </td>
                    <td style={{ width: "8%" }} className="pt-3 ">
                        {(item?.productionDTO?.productionName) ? item?.productionDTO?.productionName : item?.productionName}
                    </td>
                    <td style={{ width: "5%" }} className="pt-3">
                        {item?.temperatureInCelsius ? item?.temperatureInCelsius + ' °C' : "N/A"}
                    </td>
                    <td style={{ width: "7%" }} className="pt-3 ">
                        {item?.productionDTO?.batchCode}
                    </td>
                    <td style={{ width: "5%" }} className="pt-3">
                        {formatDate(item?.ubd)}
                    </td>
                    <td style={{ width: "7%" }} className="pt-3 text-center">
                        {formatDate(item?.productionDTO?.sellByDate)}
                    </td>
                    <td style={{ width: "4%" }} className="pt-3">
                        {item?.productionDTO?.quantity}  {item?.productionDTO?.unit}
                    </td>
                    <td style={{ width: "9%" }} className="pt-3">
                        {item?.productionDTO?.createdBy}
                    </td>

                    <td style={{ width: "4%" }}>

                        <div className="d-flex justify-content-center">
                            <Dropdown
                                overlay={
                                    <Menu>

                                        <Menu.Item
                                            key="Take"
                                            className={decodedToken?.permissions?.some(
                                                (permission) => permission?.authority === 'ADD_REHEAT_PROCESS'
                                            ) ? '' : 'd-none'}
                                            onClick={() => handleOpenReheatModal(item.id)}
                                        >
                                            <EditOutlined /> Take Temp
                                        </Menu.Item>

                                        <Menu.Item
                                            key="Stock"
                                            className={decodedToken?.permissions?.some(
                                                (permission) => permission?.authority === 'ADD_STOCK_LEVEL'
                                            ) ? '' : 'd-none'}
                                            onClick={() => handleOpenStockLevelModal(item?.productionDTO?.id)}>
                                            <FundViewOutlined /> Stock Level
                                        </Menu.Item>

                                        <Menu.Item
                                            key="Waste"
                                            className={decodedToken?.permissions?.some(
                                                (permission) => permission?.authority === 'ADD_PRODUCTION_WASTE'
                                            ) ? '' : 'd-none'}
                                            onClick={() => handleOpenWasteModal(item?.productionDTO?.id)}>
                                            <ClearOutlined /> Waste
                                        </Menu.Item>

                                        <Menu.Item
                                            key="History"
                                            onClick={() => handleOpenHistoryModal(item?.productionDTO?.id)}>
                                            <SearchOutlined /> History of Product
                                        </Menu.Item>


                                    </Menu>
                                }
                                trigger={["click"]}
                                placement="bottom"
                            >
                                <div className="action-circle">
                                    <MoreOutlined />
                                </div>
                            </Dropdown>
                        </div>
                    </td>
                </tr>
            ));
        } else {
            return (<>
                <tr className="text-center EmptyTable">
                    <td colSpan={10} className="text-center ">
                        <EmptyBox />
                    </td>
                </tr></>
            );
        }
    };

    function formatDate(date) {
        const dateNew = parseInt(date, 10);
        const options = { day: "2-digit", month: "short", year: "numeric" };
        const formattedDate = new Date(dateNew).toLocaleDateString(
            "en-US",
            options
        );

        const [month, day, year] = formattedDate.split(" ");
        const capitalizedMonth = month.toUpperCase();
        return `${day} ${capitalizedMonth} ${year}`;
    }


    return (
        <Layout style={{ minHeight: "100vh" }}>
            <Sidebar />
            <Layout>
                <TopHeader onPrintResponse2={handlePrintButtonClick2} />
                {isLoading && (
                    <div className="spinner-overlay" id="spinnerOverlay">
                        <div className="spinner"></div>
                    </div>
                )}
                <div
                    style={{
                        padding: "20px",
                        paddingBottom: "5px",
                    }}
                >
                    <Form
                        ref={formRef}
                        form={formadd2}
                        name="nest-messages"
                        layout="vertical"
                        className="FormClass FilterForm"
                        onFinish={handleSubmit}
                    >
                        <>
                            <Collapse>
                                <Panel
                                    header={
                                        <h5 className="mb-0">
                                            <b>Filter</b>
                                        </h5>
                                    }
                                    key="1"
                                >
                                    {filterRecipe.map((input, filterProductionIndex) => (
                                        <div key={filterProductionIndex}>
                                            <Row gutter={24} className="pt-2">
                                                <Col lg={5} md={5} className="px-1">
                                                    <Form.Item
                                                        name={`title${filterProductionIndex}`}
                                                        className="text-lable"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: "Please Select",
                                                            },
                                                        ]}
                                                    >
                                                        <Select
                                                            className="control-Select"
                                                            placeholder="Filter By"
                                                            value={input.title}
                                                            onChange={(value) =>
                                                                handleChangeTitle(filterProductionIndex, value)
                                                            }
                                                            options={[
                                                                {
                                                                    value: "production.sellByDate",
                                                                    label: "Sell By Date",
                                                                },
                                                                {
                                                                    value: "production.productionName",
                                                                    label: "Product description",
                                                                },
                                                                {
                                                                    value: "production.batchCode",
                                                                    label: "Batch Code",
                                                                },
                                                                {
                                                                    value: "createdDate",
                                                                    label: "Date",
                                                                },
                                                            ]}
                                                        />
                                                    </Form.Item>
                                                </Col>

                                                <Col lg={4} md={4} className="px-1">
                                                    {filterRecipe[filterProductionIndex].title ==
                                                        "production.sellByDate" || filterRecipe[filterProductionIndex].title ==
                                                        "createdDate" ? (
                                                        <>
                                                            <Form.Item
                                                                name={`nameto${filterProductionIndex}`}
                                                                className="text-lable"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: "Please Select Start Date.",
                                                                    },
                                                                ]}
                                                            >
                                                                <Input
                                                                    type="date"
                                                                    placeholder="Filter By"
                                                                    onChange={(e) =>
                                                                        handleChangeAnswertype(
                                                                            filterProductionIndex,
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    className="control-input"
                                                                />
                                                            </Form.Item>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <Form.Item
                                                                name={`type${filterProductionIndex}`}
                                                                className="text-lable"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: "Please Select type.",
                                                                    },
                                                                ]}
                                                            >
                                                                <Select
                                                                    className="control-Select mb-1"
                                                                    placeholder="Condition"
                                                                    onChange={(value) =>
                                                                        handleChangeAnswertype(
                                                                            filterProductionIndex,
                                                                            value
                                                                        )
                                                                    }
                                                                    options={[
                                                                        { value: "%", label: "Matches with" },
                                                                        {
                                                                            value: "=",
                                                                            label: "Equals to",
                                                                        },
                                                                    ]}
                                                                />
                                                            </Form.Item>
                                                        </>
                                                    )}
                                                </Col>


                                                <Col lg={5} md={5} className="px-1">
                                                    {filterRecipe[filterProductionIndex].title ==
                                                        "production.sellByDate" || filterRecipe[filterProductionIndex].title ==
                                                        "createdDate" ? (
                                                        <>
                                                            <Form.Item
                                                                name={`name${filterProductionIndex}`}
                                                                className="text-lable"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: "Please Select End Date.",
                                                                    },
                                                                ]}
                                                            >
                                                                <Input
                                                                    type="date"
                                                                    onChange={(e) =>
                                                                        handleChangename(
                                                                            filterProductionIndex,
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    placeholder="Text"
                                                                    className="control-input"
                                                                />
                                                            </Form.Item>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <Form.Item
                                                                name={`name${filterProductionIndex}`}
                                                                className="text-lable"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: "Please enter Text.",
                                                                    },
                                                                ]}
                                                            >
                                                                <Input
                                                                    type="text"
                                                                    onChange={(e) =>
                                                                        handleChangename(
                                                                            filterProductionIndex,
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    placeholder="Text"
                                                                    className="control-input"
                                                                />
                                                            </Form.Item>
                                                        </>
                                                    )}
                                                </Col>


                                                <Col lg={8} md={10} className="px-1">
                                                    <Form.Item className="text-lable">
                                                        {filterProductionIndex == 0 ? (
                                                            <>
                                                                <Row gutter={23} className="mb-3">
                                                                    <Col span={2} className="mx-0">
                                                                        <Form.Item className="text-lable">
                                                                            <PlusCircleTwoTone
                                                                                onClick={handleAddfilterRecipe}
                                                                            />
                                                                        </Form.Item>
                                                                    </Col>

                                                                    <Col span={10}>
                                                                        <Button
                                                                            type="primary"
                                                                            htmlType="submit"
                                                                            className="btn btn-primary btn-save table-action icon-center "
                                                                        >
                                                                            Filter
                                                                        </Button>
                                                                    </Col>
                                                                    <Col span={10}>
                                                                        <Button
                                                                            type="reset"
                                                                            htmlType="reset"
                                                                            onClick={() => handleClear()}
                                                                            style={{ color: "#0b5ed7" }}
                                                                            className="btn btn-primary btn-back table-action icon-center"
                                                                        >
                                                                            Clear
                                                                        </Button>
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                        ) : (
                                                            <>
                                                                {" "}
                                                                <MinusCircleTwoTone
                                                                    onClick={() =>
                                                                        handleRemovefilterProduction(
                                                                            filterProductionIndex
                                                                        )
                                                                    }
                                                                />
                                                            </>
                                                        )}
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </div>
                                    ))}
                                </Panel>
                            </Collapse>
                        </>
                    </Form>
                </div>
                <Content
                    className="form-content nav-content"
                    style={{
                        margin: "14px 16px 0",
                        padding: "30px",
                        background: "white",
                    }}
                >
                    <div>
                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                                <></>
                            </div>
                            <div>

                                <Form
                                    form={formPaginate}
                                >
                                    <Form.Item
                                        name="paginate"
                                        className="text-lable"
                                        style={{ width: '100px' }}
                                    >
                                        <Select
                                            className="control-Select"
                                            onChange={(value) => {
                                                handlesetPaginateLimit(value)
                                            }}
                                            options={[
                                                { value: 10, label: "10" },
                                                { value: 20, label: "20" },
                                                { value: 30, label: "30" },
                                                { value: 40, label: "40" },
                                                { value: 50, label: "50" },
                                            ]}
                                        />
                                    </Form.Item>
                                </Form>

                            </div>
                        </div>
                        <table className="table users-table">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Time</th>
                                    <th>Product Name</th>
                                    <th>Temp</th>
                                    <th>Batch Code</th>
                                    <th>OUBD</th>
                                    <th>Sell by Date</th>
                                    <th>Quantity</th>
                                    <th>Reheated by</th>
                                    <th className="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>{renderTableRows()}</tbody>
                        </table>

                       {paginatedData.length > 0 && (
                        <Pagination
                            currentPage={currentPage}
                            totalPages={PaginatetotalPages}
                            onPageChange={handlePageChange}
                            maxVisiblePages={5}
                            showPageInfo={true}
                            totalItems={totalElements}
                            pageSize={PaginateLimit}
                        />
                        )}

                    </div>
                </Content>
                {modalReheatVisible &&
                    <AddTempReheat
                        visible={modalReheatVisible}
                        onClose={handlReheatCloseModal}
                        ProductctionDetails={modalReheatData}
                    />
                }
                {modalwasteVisible &&
                    <AddWaste
                        visible={modalwasteVisible}
                        onClose={handlwasteCloseModal}
                        ProductionDetails={modalwasteData}
                        ingredientDetails={StockLevelIncreadiant}
                    />
                }
                {modalStockLevelVisible &&
                    <StockLevel
                        visible={modalStockLevelVisible}
                        onClose={handlEditeCloseModal}
                        afterCookId={modalStockLevelData}
                        StockLevelProducts={StockLevelProducts}
                        StockLevelIncreadiant={StockLevelIncreadiant}
                    />
                }
                {modalHistoryVisible &&
                    <HistoryProduct
                        visible={modalHistoryVisible}
                        onClose={handlHistoryCloseModal}
                        ProductionData={modalHistoryData}
                        ProductionData2={modalHistoryData2}
                    />
                }
                {/* <FooterDashboard /> */}
            </Layout>
        </Layout>
    );
};

export default Reheat;
